import React from 'react';
import { RuleApiDataAccess } from '../../Rules/RuleApiDataAccess';
import { DataManager } from '../../../dataControls/DataManager';
import { DropdownDataSourceDataControl } from '../../../dataControls/DropdownDataSourceDataControl';
import { DropdownListDataControl } from '../../../dataControls/DropdownListDataControl';
import { TextboxDataControl } from '../../../dataControls/TextboxDataControl';
import { Card, Row, Column } from '../../../components/Containers';
import { Logger } from "../../../infrastructure/Logger";
import { InterfaceMode, ToolbarComponent } from '../../../dataForms/GenericComponent';
import { ImageTitle } from '../../../core/ImageTitle';
import { DielineImage } from '../../../components/DielineImage';
import { Banner } from '../../../components/Banner';
import { Features } from '../../../infrastructure/Constants';
import { ApiDataAccess } from '../../../infrastructure/ApiDataAccess';

import './StandardProductEditorComponent.css';

export class StandardProductEditorComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isValid: false,
            isDielineDrawable: false,
            featureOptions: {},
            structureSpecs: []
        };

        this.onValidated = this.onValidated.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
        this.onDielineVisualizerInit = this.onDielineVisualizerInit.bind(this);
        this.onDielineImageLoaded = this.onDielineImageLoaded.bind(this);
        this.updateDieline = this.updateDieline.bind(this);
        this.onControlBound = this.onControlBound.bind(this);
        this.onBindingComplete = this.onBindingComplete.bind(this);
        this.validateRules = this.validateRules.bind(this);
        this.onFeatureOffsetChange = this.onFeatureOffsetChange.bind(this);

        this.isCopy = this.props.isCopy;
        this.dielineVisualizer = null;
        this.isInitialized = false;
        this.isDielineValid = false;
        this.isRecalculating = false;
        this.selections = {};

        this.gussetRequired = false;
        this.bottomFillEnabled = false;
        this.zipperOffsetEnabled = true;
        this.hangHoleOffsetEnabled = true;
        this.tearNotchOffsetEnabled = true;
        this.valveOffsetEnabled = true;
        this.eyemarkEnabled = true;
        this.lengthUomId = 13; // to manage, now inches is hard coded

        this.ruleDataAccess = new RuleApiDataAccess();
        this.dataAccess = new ApiDataAccess('data/structurespecs/');
        this.dataManager = new DataManager('standard-product', this.onControlBound, this.onControlUnbound, this.onValidated, this.onBindingComplete);
    }

    componentDidMount() {
        this.dataManager.init()
            .then(dataManager => {
                //1) load standard product data
                if (this.props.dataId) {
                    dataManager.loadContext(this.props.dataId)
                        .then(() => {

                            if (this.isCopy)
                                dataManager.dataObject.id = undefined; // if it is a copy it unset the id, otherwise an update is performed

                            dataManager.bindControls();
                        })
                        .catch(ex => {
                            Logger.writeError("Could not load Standard Product", ex);
                            window.Router.setNotFound();
                        });
                }
                else
                    dataManager.bindControls();
            });
    }

    onValidated(isValid) {

        var isDielineDrawable = isValid ? true : this.isDielineDrawable(this.dataManager.controls);
        if (this.hasSomethingChanged())
        {
            this.selections = this.getSelections();
            if (isDielineDrawable) {
                this.validateRules();
                this.updateDieline();
            }
            this.loadStructureSpecs();
        }

        this.setState({
            isValid: isValid,
            isDielineDrawable: isDielineDrawable
        });
    }

    onControlBound(control, propertyName) {
        var value = this.dataManager.dataObject[propertyName];
        if (value) {
            control.setValue(value, control);
        }
    }

    onBindingComplete() {
        this.isInitialized = true;
    }

    onControlUnbound(control, propertyName) {
    }

    isDielineDrawable(control) {
        return control.convertingMethodId.currentValue > 0 &&
            !!control.length.currentValue &&
            !!control.width.currentValue &&
            control.eyemarkId.currentValue > 0
    }

    onDielineImageLoaded(data) {
        if (data)
            if (data.errorCodes && data.errorCodes.length > 0)
                this.setState({
                    isValid: false
                });
    }

    updateDieline() {
        if (this.dielineVisualizer) {
            var dielineRequest = this.getSelections();
            dielineRequest.ignoreErrorCodes = this.state.featureOptions?.ignoreDielineErrorCodes;
            this.dielineVisualizer.setNewDielineRequest(dielineRequest);
        }
    }

    validateRules() {
        this.ruleDataAccess.processRules(
            this.selections.width,
            this.selections.length,
            this.selections.gusset,
            this.selections.convertingMethodId,
            this.selections.tearNotchId,
            this.selections.tearNotchOffset,
            this.selections.hangholeId,
            this.selections.hangHoleOffset,
            this.selections.valveId,
            this.selections.valveOffset,
            this.selections.zipperId,
            this.selections.zipperOffset,
            this.selections.doubleCutId,
            this.selections.sealWidthId,
            this.selections.gussetTypeId,
            this.selections.roundedCornersId
        ).then(data => {
            this.setState({
                featureOptions: data
            });
        })
    }

    loadStructureSpecs() {
        const selections = this.getSelections();

        if (selections.convertingMethodId &&
            selections.length && selections.length > 0
            && selections.width && selections.width > 0)
        {
            this.dataAccess.post('filter', {
                uomId: this.lengthUomId,
                length: selections.length,
                width: selections.width,
                convertingMethodId: selections.convertingMethodId
            })
                .then(data => {
                    this.setState({ structureSpecs: data });
                })
                .catch(error => {
                    Logger.writeError("Could not load Structure Specs", error);
                    this.setState({ structureSpecs: [] });
                });
        }
        else
        {
            this.setState({ structureSpecs: [] });
        }
    }

    hasSomethingChanged() {
        return JSON.stringify(this.selections) !== JSON.stringify(this.getSelections());
    }

    getSelections() {
        return {
            width: this.dataManager.controls.width?.currentValue,
            length: this.dataManager.controls.length?.currentValue,
            gusset: this.dataManager.controls.gusset?.currentValue,
            eyemarkId: this.dataManager.controls.eyemarkId?.currentValue,
            convertingMethodId: this.dataManager.controls.convertingMethodId?.currentValue,
            structureSpecId: this.dataManager.controls.structureSpecId?.currentValue,
            bottomFillId: this.dataManager.controls.bottomFillId?.currentValue,
            doubleCutId: this.dataManager.controls.doubleCutId?.currentValue,
            gussetTypeId: this.dataManager.controls.gussetTypeId?.currentValue,
            roundedCornersId: this.dataManager.controls.roundedCornersId?.currentValue,
            sealWidthId: this.dataManager.controls.sealWidthId?.currentValue,
            tearNotchId: this.dataManager.controls.tearNotchId?.currentValue,
            tearNotchOffset: this.dataManager.controls.tearNotchOffset?.currentValue,
            hangHoleId: this.dataManager.controls.hangHoleId?.currentValue,
            hangHoleOffset: this.dataManager.controls.hangHoleOffset?.currentValue,
            valveId: this.dataManager.controls.valveId?.currentValue,
            valveOffset: this.dataManager.controls.valveOffset?.currentValue,
            zipperId: this.dataManager.controls.zipperId?.currentValue,
            zipperOffset: this.dataManager.controls.zipperOffset?.currentValue,
            lengthUomId: this.lengthUomId
        }
    }

    // recalculate offset for all feature where offset is set by a feature rule
    onFeatureOffsetChange() {
        if (!this.isRecalculating) {
            this.isRecalculating = true;

            var selectedHangHole = this.dataManager.controls.hangHoleId.selectedItem;
            if (selectedHangHole?.offset) {
                this.onFeatureWithOffsetSelectionChange(selectedHangHole, Features.HangHole);
            }
            var selectedTearNotch = this.dataManager.controls.tearNotchId.selectedItem;
            if (selectedTearNotch?.offset) {
                this.onFeatureWithOffsetSelectionChange(selectedTearNotch, Features.TearNotch)
            }
            var selectedValve = this.dataManager.controls.valveId.selectedItem;
            if (selectedValve?.offset) {
                this.onFeatureWithOffsetSelectionChange(selectedValve, Features.Vent);
            }
            var selectedZipper = this.dataManager.controls.zipperId.selectedItem;
            if (selectedZipper?.offset) {
                this.onFeatureWithOffsetSelectionChange(selectedZipper, Features.Zipper);
            }

            this.isRecalculating = false;
        }
    }

    onFeatureWithOffsetSelectionChange(selectedItem, feature) {
        if (selectedItem) {
            var location = this.getFeatureLocation(selectedItem);
            var required = !!location;
            var enabled = required && !selectedItem.offset;
            this.setValue(feature.RelatedFeatureName, location, required, enabled);
        }
    }

    getFeatureLocation(featureOption) {
        if (featureOption.offset) {
            var featureOffset = 0;
            var relatedFeature = featureOption.offset.offsetToRelatedFeatureName;
            var offsetFromFeature = featureOption.offset.offset;

            if (relatedFeature.includes(Features.TearNotch.Name))
                featureOffset = this.dataManager.controls.tearNotchOffset.currentValue;
            else if (relatedFeature.includes(Features.HangHole.Name))
                featureOffset = this.dataManager.controls.hangHoleOffset.currentValue;
            else if (relatedFeature.includes(Features.Vent.Name))
                featureOffset = this.dataManager.controls.valveOffset.currentValue;
            else if (relatedFeature.includes(Features.Zipper.Name))
                featureOffset = this.dataManager.controls.zipperOffset.currentValue;

            var result = (featureOffset - offsetFromFeature).toFixed(4);
            return result > 0 ? result : 0;
        }
        if (featureOption.defaultLocation)
            return featureOption.defaultLocation;

        return '';
    }

    onConvertingMethodChange(selectedItem) {
        if (selectedItem) {
            // set gusset
            this.gussetRequired = selectedItem.gussetRequired;

            // set bottom fill
            this.bottomFillEnabled = selectedItem.bottomFillAllowChange;
            if (!this.bottomFillEnabled)
                this.setValue(Features.BottomFill, selectedItem.bottomFillDefaultId);

            // set eyemark
            this.eyemarkEnabled = selectedItem.eyemarkAllowChange;
            if (!this.eyemarkEnabled)
                this.setValue(Features.Eyemark, selectedItem.eyemarkDefaultId);
        }
    }

    onDielineVisualizerInit(ctrl) {
        this.dielineVisualizer = ctrl;
    }

    setValue(feature, value, required, enabled) {
        switch (feature) {
            case Features.Zipper.RelatedFeatureName:
                // do not trigger offset change until initialization is complete, otherwise it will replace existing values with default ones during edit or copy
                if (this.isInitialized)
                    this.dataManager.controls.zipperOffset.onChange(null, value, required);
                this.zipperOffsetEnabled = enabled;
                break;
            case Features.HangHole.RelatedFeatureName:
                if (this.isInitialized)
                    this.dataManager.controls.hangHoleOffset.onChange(null, value, required);
                this.hangHoleOffsetEnabled = enabled;
                break;
            case Features.TearNotch.RelatedFeatureName:
                if (this.isInitialized)
                    this.dataManager.controls.tearNotchOffset.onChange(null, value, required);
                this.tearNotchOffsetEnabled = enabled;
                break;
            case Features.Vent.RelatedFeatureName:
                if (this.isInitialized)
                    this.dataManager.controls.valveOffset.onChange(null, value, required);
                this.valveOffsetEnabled = enabled;
                break;
            case Features.BottomFill:
                this.dataManager.controls.bottomFillId.onChange(null, value);
                break;
            case Features.Eyemark:
                this.dataManager.controls.eyemarkId.onChange(null, value);
                break;
            default:
                return;
        }
    }

    onSaveClick() {
        var self = this;
        self.dataManager.saveContext()
            .then(data => {
                window.Alerts.showSuccess(data.name + ' has been saved');
                window.Router.setRoute('/standard-products/' + encodeURIComponent(data.id));
            })
            .catch(error => {
            });
    }

    render() {
        return (
            <div className='standard product standard-product-editor-component'>


                <ImageTitle text='Standard Products' />

                <ToolbarComponent mode={this.props.dataId ? InterfaceMode.Edit : InterfaceMode.New}
                    onListClick={() => window.Router.setRoute('/standard-products/all')}
                    onNewClick={() => window.Router.setRoute('/standard-products/new')}
                    onEditClick={() => window.Router.setRoute('/standard-products/' + encodeURIComponent(this.props.dataId) + '/edit')}
                    onDisplayClick={() => window.Router.setRoute('/standard-products/' + encodeURIComponent(this.props.dataId))}
                />

                <Card title='Packaging Type' subtitle='Define the Packaging Type Below'>
                    <Row>
                        <Column>
                            <label htmlFor='Pouch Type'>Pouch Type</label>
                            <DropdownDataSourceDataControl
                                dataManager={this.dataManager}
                                propertyName='convertingMethodId'
                                onChange={(value, control, selectedItem) => this.onConvertingMethodChange(selectedItem)} />
                        </Column>
                    </Row>
                    <Row>
                        <Column>
                            <label htmlFor='Width'>Width</label>
                            <TextboxDataControl dataManager={this.dataManager} propertyName='width' />
                        </Column>
                    </Row>
                    <Row>
                        <Column>
                            <label htmlFor='Length'>Length</label>
                            <TextboxDataControl dataManager={this.dataManager} propertyName='length' />
                        </Column>
                    </Row>
                    {
                        this.gussetRequired &&
                        <Row>
                            <Column>
                                <label htmlFor='Gusset'>Gusset</label>
                                <TextboxDataControl dataManager={this.dataManager} propertyName='gusset' />
                            </Column>
                        </Row>
                    }
                    <Row>
                        <Column>
                            <label htmlFor='Bottom Fill'>Bottom Fill</label>
                            <DropdownDataSourceDataControl
                                dataManager={this.dataManager}
                                propertyName='bottomFillId'
                                disabled={!this.bottomFillEnabled}
                            />
                        </Column>
                    </Row>
                    <Row>
                        <Column>
                            <label htmlFor='Eyemark Placement'>Eyemark Placement</label>
                            <DropdownDataSourceDataControl
                                dataManager={this.dataManager}
                                propertyName='eyemarkId'
                                disabled={!this.eyemarkEnabled}
                            />
                        </Column>
                    </Row>
                </Card>

                <Card title='Packaging Material' subtitle='Select the Packaging Material Below'>
                    <Row>
                        <Column>
                            <label htmlFor='Packaging Material'>Packaging Material</label>
                            <DropdownListDataControl
                                list={this.state.structureSpecs}
                                dataManager={this.dataManager}
                                propertyName='structureSpecId' />
                        </Column>
                    </Row>
                </Card>

                <Card title='Packaging Features' subtitle='Select the Packaging Features Below'>
                    <Banner title="Rules Applied" strings={this.state.featureOptions.rulesApplied} />
                    <div className="standard-product-packaging-features">
                        <div className="selections">
                            <Row>
                                <Column>
                                    <label htmlFor='Zipper'>Zipper</label>
                                    <DropdownListDataControl
                                        list={this.state.featureOptions.zippers}
                                        dataManager={this.dataManager}
                                        propertyName='zipperId'
                                        onChange={(value, control, selectedItem) => this.onFeatureWithOffsetSelectionChange(selectedItem, Features.Zipper)} />
                                </Column>
                                <Column>
                                    <label htmlFor='Offset'>Offset</label>
                                    <TextboxDataControl
                                        dataManager={this.dataManager}
                                        propertyName='zipperOffset'
                                        disabled={true} // temporary disabled
                                        // disabled={!this.zipperOffsetEnabled}
                                        onChange={this.onFeatureOffsetChange}
                                    />
                                </Column>
                            </Row>
                            <Row>
                                <Column>
                                    <label htmlFor='Hang Hole'>Hang Hole</label>
                                    <DropdownListDataControl
                                        list={this.state.featureOptions.hangHoles}
                                        dataManager={this.dataManager}
                                        propertyName='hangHoleId'
                                        onChange={(value, control, selectedItem) => this.onFeatureWithOffsetSelectionChange(selectedItem, Features.HangHole)} />
                                </Column>
                                <Column>
                                    <label htmlFor='Offset'>Offset</label>
                                    <TextboxDataControl
                                        dataManager={this.dataManager}
                                        propertyName='hangHoleOffset'
                                        disabled={true} // temporary disabled
                                        //disabled={!this.hangHoleOffsetEnabled}
                                        onChange={this.onFeatureOffsetChange}
                                    />
                                </Column>
                            </Row>
                            <Row>
                                <Column>
                                    <label htmlFor='Tear Notch'>Tear Notch</label>
                                    <DropdownListDataControl
                                        list={this.state.featureOptions.tearNotches}
                                        dataManager={this.dataManager}
                                        propertyName='tearNotchId'
                                        onChange={(value, control, selectedItem) => this.onFeatureWithOffsetSelectionChange(selectedItem, Features.TearNotch)} />
                                </Column>
                                <Column>
                                    <label htmlFor='Offset'>Offset</label>
                                    <TextboxDataControl
                                        dataManager={this.dataManager}
                                        propertyName='tearNotchOffset'
                                        disabled={true} // temporary disabled
                                        //disabled={!this.tearNotchOffsetEnabled}
                                        onChange={this.onFeatureOffsetChange}
                                    />
                                </Column>
                            </Row>
                            <Row>
                                <Column>
                                    <label htmlFor='Valve'>Valve</label>
                                    <DropdownListDataControl
                                        list={this.state.featureOptions.vents}
                                        dataManager={this.dataManager}
                                        propertyName='valveId'
                                        onChange={(value, control, selectedItem) => this.onFeatureWithOffsetSelectionChange(selectedItem, Features.Vent)} />
                                </Column>
                                <Column>
                                    <label htmlFor='Offset'>Offset</label>
                                    <TextboxDataControl
                                        dataManager={this.dataManager}
                                        propertyName='valveOffset'
                                        disabled={true} // temporary disabled
                                        //disabled={!this.valveOffsetEnabled}
                                        onChange={this.onFeatureOffsetChange}
                                    />
                                </Column>
                            </Row>
                            <Row>
                                <Column>
                                    <label htmlFor='Rounded Corners'>Rounded Corners</label>
                                    <DropdownListDataControl
                                        list={this.state.featureOptions.roundedCorners}
                                        dataManager={this.dataManager}
                                        propertyName='roundedCornersId' />
                                </Column>
                                <Column />
                            </Row>
                            <Row>
                                <Column>
                                    <label htmlFor='Double Cut'>Double Cut</label>
                                    <DropdownListDataControl
                                        list={this.state.featureOptions.doubleCuts}
                                        dataManager={this.dataManager}
                                        propertyName='doubleCutId' />
                                </Column>
                                <Column />
                            </Row>
                            <Row>
                                <Column>
                                    <label htmlFor='Gusset Type'>Gusset Type</label>
                                    <DropdownListDataControl
                                        list={this.state.featureOptions.gussetTypes}
                                        dataManager={this.dataManager}
                                        propertyName='gussetTypeId' />
                                </Column>
                                <Column />
                            </Row>
                            <Row>
                                <Column>
                                    <label htmlFor='Seal Width'>Seal Width</label>
                                    <DropdownListDataControl
                                        list={this.state.featureOptions.sealWidths}
                                        dataManager={this.dataManager}
                                        propertyName='sealWidthId' />
                                </Column>
                                <Column />
                            </Row>
                        </div>
                        <div className="dieline">
                            {
                                this.state.isDielineDrawable &&
                                <>
                                    <label htmlFor='Dieline'>Dieline</label>
                                    <DielineImage
                                        id={1}
                                        onInit={this.onDielineVisualizerInit}
                                        onLoaded={this.onDielineImageLoaded}
                                        zoom={1.5}
                                        lengthUomId={this.selections.lengthUomId}
                                        convertingMethodId={this.selections.convertingMethodId}
                                        length={this.selections.length}
                                        width={this.selections.width}
                                        gusset={this.selections.gusset}
                                        gussetTypeId={this.selections.gussetTypeId}
                                        tearNotchId={this.selections.tearNotchId}
                                        tearLineOffset={this.selections.tearNotchOffset}
                                        hangholeId={this.selections.hangholeId}
                                        hangholeOffset={this.selections.hangholeOffset}
                                        zipperId={this.selections.zipperId}
                                        zipperOffset={this.selections.zipperOffset}
                                        eyemarkId={this.selections.eyemarkId}
                                        bottomFillId={this.selections.bottomFillId}
                                        valveId={this.selections.valveId}
                                        valveOffset={this.selections.valveOffset}
                                        sideSealWidthId={this.selections.sideSealWidthId}
                                        roundedCornerId={this.selections.roundedCornersId}
                                        doubleCutId={this.selections.doubleCutId}
                                    />
                                </>
                            }
                        </div>
                    </div>
                </Card>
                <button className='btn btn-lg btn-primary' onClick={() => window.Router.setRoute('/standard-products/all')}>Cancel</button>
                <button className='btn btn-secondary pull-right' disabled={!this.state.isValid} onClick={this.onSaveClick}>Save</button>
            </div>
        );
    }
}